import React, { Component } from "react";
import { FiArrowUpRight } from "react-icons/fi";

class Nakbho extends Component {
    render() {
        let subtitle = 'Our Flagship Product',
            title = 'NAKBHO Healthcare',
            subheading = 'One Patient, One Record. Connected Healthcare Worldwide',
            description = 'From a single healthcare facility to an entire nation, NAKBHO brings patients, healthcare professionals and health systems together through one connected digital ecosystem.',
            description2 = 'Designed to make healthcare more accessible, efficient and connected — wherever care happens.';
        return (
            <React.Fragment>
                <div className="about-wrapper">
                    <div className="container">
                        <div className="row row--35 align-items-center">
                            <div className="col-lg-5 col-md-12">
                                <div className="about-inner inner">
                                    <div className="section-title">
                                        <span className="subtitle">{subtitle}</span>
                                        <h2 className="title">{title}</h2>
                                        <h4 className="mb--20">{subheading}</h4>
                                        <p className="description">{description}</p>
                                        <p className="description">{description2}</p>
                                        <div className="mt--30">
                                            <a className="rn-button-style--2 btn-black" href="https://nakbho.com/" target="_blank" rel="noopener noreferrer">Explore NAKBHO <FiArrowUpRight style={{ verticalAlign: "-2px", marginLeft: "4px" }} /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-12">
                                <div className="thumbnail mt_md--40 mt_sm--40">
                                    {/* <img className="w-100" src="/assets/images/about/nakbho-ecosystem.webp" alt="NAKBHO Healthcare connected ecosystem" /> */}
                                    <img className="w-100" src="/assets/images/about/nakbho.png" alt="NAKBHO Healthcare connected ecosystem" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default Nakbho;
